import { render, staticRenderFns } from "./certificateTable.vue?vue&type=template&id=37394ce2&scoped=true"
import script from "./certificateTable.vue?vue&type=script&lang=js"
export * from "./certificateTable.vue?vue&type=script&lang=js"
import style0 from "./certificateTable.vue?vue&type=style&index=0&id=37394ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37394ce2",
  null
  
)

export default component.exports